import React from "react";
import PropTypes from "prop-types";

import { IconAction } from "./IconAction";

const INTENTS = ["primary", "secondary", "quiet", "destructive"];

export function IconButton({
  disabled = false,
  icon,
  intent = "secondary",
  label,
  loading = false,
  loadingLabel,
  onClick,
  type = "button",
}) {
  return (
    <IconAction
      disabled={disabled}
      icon={icon}
      intent={intent}
      label={label}
      loading={loading}
      loadingLabel={loadingLabel}
      onClick={onClick}
      type={type}
    />
  );
}

IconButton.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  intent: PropTypes.oneOf(INTENTS),
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
};
